import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import ROUTES_NAVIGATION from "../../../../routes/routes";
import axiosInstance from "../../../../services/api/API";
import CustomTable from "../../../../customComponents/CustomTable";
// import viewIcon from "../../../../../Assets/icons/viewDetails.svg"
import eyeIcon from "../../../../../Assets/icons/eye 1.svg";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import viewIcon from "../../../../../Assets/icons/ClaimIcon.svg";
import ListLogisticsFilters from "../../../Logistics/LogisticsFilter";
import { FiDownload } from "react-icons/fi";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import CustomHorizontalTable from "../../../../customComponents/CustomHorizontalTable";

const AdminWarrantyCheck = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const [selectedWarrantyType, setSelectedWarrantyType] =
    useState("Dealer Side"); // "admin", "dealer", or ""

  const [currentPage, setCurrentPage] = useState(0);
  const [dealerOption, setDealerOptions] = useState([]);

  const [modelOptions, setModelOptions] = useState([]);
  const [variantOptions, setVariantOptions] = useState([]);
  const [totalPages, setTotalPages] = useState(0);

  const [filterList, setFilterList] = useState();
  const [filterFormData, setFilterFormData] = useState({});

  const [totalRecords, setTotalRecored] = useState(0);

  const [filters, setFilters] = useState({});

  const [vinNoData, setVinNoData] = useState([]);

  const [isSearchPerformed, setIsSearchPerformed] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [validationErrors, setValidationErrors] = useState({});
  const [remainingDays, setRemainingDays] = useState(0);

  const navigate = useNavigate();

  const token = localStorage.getItem("authToken");

  localStorage.removeItem("JobCardComplainData");

  useEffect(() => {
    fetchJobCardList();
  }, [filterList]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);

    // fetchJobCardList(newPage);
  };

  useEffect(() => {
    fetchDealers();
  }, []);

  const fetchDealers = async () => {
    try {
      const response = await axiosInstance.post("/dealer/ddldealer", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response?.data?.data?.data;

      const dealerOptions = data.map((dealer) => ({
        value: dealer.dealer_id,
        label: dealer.dealer_name,
      }));

      setDealerOptions(dealerOptions);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchModelOptions();
  }, []);

  const fetchModelOptions = async () => {
    try {
      const payload = {
        orderBy: "model_id desc",
        page: 0,
        pageSize: 100,
      };

      const response = await axiosInstance.post("/model/ddlmodel", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));
      console.log(options, "responseVal");

      setModelOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  useEffect(() => {
    // const colorId = formData.color
    const modelId = filterFormData.modelId;

    if (modelId) {
      fetchVariantOptions(modelId);
    }
  }, [filterFormData.modelId]);

  const fetchVariantOptions = async (modelId) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.post(
        "/variant/ddlvariant",
        {
          // color_id: colorId,
          model_id: modelId,
          // dealer_id:dealer_id
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setVariantOptions(options);
    } catch (error) {
      console.error("Error fetching variant options:", error);
    }
  };
  const fetchJobCardList = async () => {
    const payload = {
      // business_partner_id: 1,

      vinNumber: searchTerm,
      modelId: filterFormData.modelId || "",
      variantId: filterFormData.variantId || "",
      dealerId: filterFormData.dealerId || "",
    };

    try {
      // setTableLoader(true)

      const response = await axiosInstance.post(
        "/sales/vin-check-oem-warranty",

        payload,

        {
          headers: {
            "Content-Type": "application/json",

            Authorization: `Bearer ${token}`,
          },
        }
      );

      // setTableLoader(false)

      if (response?.data?.data?.status === 500) {
        setErrorMessage(response.data.data.message);

        setVinNoData([]); // Clear any previous data
        setTotalRecored(0);
      } else {
        const formattedData = response?.data?.data?.respData?.map(
          (item, index) => ({
            ...item,
            btybtryremaining_days: item.btybtryremaining_days || "--",
            cntrlremaining_days: item.cntrlremaining_days || "--",
            mtrremaining_days: item.mtrremaining_days || "--",
            chrgrremaining_days: item.chrgrremaining_days || "--",
            covrtremaining_days: item.covrtremaining_days || "--",
          })
        );

        const navigateDays = formattedData[0]?.remaining_days;

        console.log(navigateDays, "navigateDays");

        setRemainingDays(navigateDays);

        setVinNoData(formattedData);
        setCurrentPage(0);

        setErrorMessage(""); // Clear any error message
      }

      setIsSearchPerformed(true); // Ensure search is marked as performed
    } catch (error) {
      console.error("Error fetching business partners:", error);

      setIsSearchPerformed(false);

      setErrorMessage("An error occurred while fetching data.");
    }
  };
  useEffect(() => {
    if (selectedWarrantyType === "Customer Side") {
      fetchCustomerWarrantyData();
    }
  }, [selectedWarrantyType]);

  const fetchCustomerWarrantyData = async () => {
    const payload = {
      // business_partner_id: 1,

      vinNumber: searchTerm,
      modelId: filterFormData.modelId || "",
      variantId: filterFormData.variantId || "",
      dealerId: filterFormData.dealerId || "",
    };

    try {
      // setTableLoader(true)

      const response = await axiosInstance.post(
        "/sales/customer-vin-check-oem-warranty",
        payload,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // setTableLoader(false)

      if (response?.data?.data?.status === 500) {
        setErrorMessage(response.data.data.message);
        setVinNoData([]); // Clear any previous data
      } else {
        const formattedData = response?.data?.data?.respData?.map(
          (item, index) => ({
            ...item,
            ...item,
            btybtryremaining_days: item.btybtryremaining_days || "--",
            cntrlremaining_days: item.cntrlremaining_days || "--",
            mtrremaining_days: item.mtrremaining_days || "--",
            chrgrremaining_days: item.chrgrremaining_days || "--",
            covrtremaining_days: item.covrtremaining_days || "--",
          })
        );

        const navigateDays = formattedData[0]?.remaining_days;
        console.log(navigateDays, "navigateDays");
        setRemainingDays(navigateDays);
        setVinNoData(formattedData);
        setCurrentPage(0);

        setErrorMessage(""); // Clear any error message
      }
      setIsSearchPerformed(true); // Ensure search is marked as performed
    } catch (error) {
      console.error("Error fetching business partners:", error);
      setIsSearchPerformed(false);
      setErrorMessage("An error occurred while fetching data.");
    }
  };

  const itemsPerPage = 10;
  const filteredData = selectedWarrantyType
    ? vinNoData.filter((item) => item.warrantyType === selectedWarrantyType)
    : vinNoData;

  const paginatedData = filteredData.slice(
    currentPage * itemsPerPage,
    currentPage * itemsPerPage + itemsPerPage
  );

  useEffect(() => {
    setTotalPages(Math.ceil(filteredData.length / itemsPerPage));
  }, [filteredData]);

  const onClickNavigetion = (item) => {
    return (
      <div onClick={() => handleEdit(item)}>
        <span style={{ color: "green" }}> {item?.job_card_no}</span>
      </div>
    );
  };

  const handleEdit = (rowData) => {
    navigate("add-job-card", {
      state: { jobCardDataDetails: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  const handleViewButton = (rowData) => {
    console.log("rowdata>", rowData);

    navigate(`${ROUTES_NAVIGATION.SALESWARRANTYCHECKDETAILS}`, {
      state: { data: rowData },
    });

    // console.log("rowdata", rowData)
  };

  // Table headers
  const PhysicalStockTakingInputs = [
    {
      name: "dealerId",
      label: "Dealer ",
      placeholder: "Select Dealer",
      type: "dropdown",
      options: dealerOption,
      // required: true,
      gridClass: "col-lg-3",
    },
    {
      // name: "variant",
      name: "modelId",
      label: "Model",
      placeholder: "",
      type: "dropdown",
      options: modelOptions,
      // required: true,
      gridClass: "col-lg-3",
      // validation: { required: true },
    },
    {
      // name: "variant",
      name: "variantId",
      label: "Variant",
      placeholder: "",
      type: "dropdown",
      options: variantOptions,
      // required: true,
      gridClass: "col-lg-3",
      // validation: { required: true },
    },
  ];

  // const Job_Card_TABLE_HEADERS = [
  //   // ...(selectedWarrantyType === "Dealer Side" ? ["Grace Period"] : []),
  //   "Name",
  //   "Vin No.",
  //   "Serial No.",
  //   "Mobile No.",

  //   "Dealer Buy Date",
  //   ...(selectedWarrantyType !== "Dealer Side" ? ["Rider Buy Date"] : []),

  //   // "Days",

  //   // "Warranty From",

  //   // "Warranty To",

  //   // "Battery No",

  //   // "Battery From",

  //   // "Battery To",

  //   // "Battery Days",
  //   "Battery Remaining days (including grace period)",
  //   "Controller Remaining days (including grace period)",
  //   "Motor Remaining days (including grace period)",
  //   "Charger Remaining days (including grace period)",
  //   "Converter Reamining days (including grace period)",
  //   ...(selectedWarrantyType !== "Customer Side" ? ["Dealer Selling Date"] : []),
  //   "Action",
  // ];

  const formatHeader = (label) =>
    selectedWarrantyType === "Customer Side"
      ? label.replace(" (including grace period)", "")
      : label;
  
  const Job_Card_TABLE_HEADERS = [
    "Name",
    "Vin No.",
    "Serial No.",
    "Mobile No.",
    "Dealer Buy Date",
    ...(selectedWarrantyType !== "Dealer Side" ? ["Customer Buy Date"] : []),
    formatHeader("Motor Remaining days"),
    formatHeader("Controller Remaining days"),
    formatHeader("Converter Reamining days"),
  
    formatHeader("Battery Remaining days"),

    formatHeader("Battery Replacement Remaining days"),
    formatHeader("MCB Remaining days"),
    formatHeader("Throttle Remaining days"),
    formatHeader("Horn Remaining days"),
    formatHeader("Lights Remaining days"),
    formatHeader("Ignition Key Remaining days"),
    formatHeader("Shock Absorbers Remaining days"),
    formatHeader("Wiring Remaining days"),

    formatHeader("Charger Remaining days"),
  
    ...(selectedWarrantyType !== "Customer Side" ? ["Dealer Selling Date"] : []),
    "Action",
  ];

  // Key mapping for CustomTable component

  // const BUSINESS_PARTNER_KEY_MAPPING = {
  //   // "Grace Period": 'grace_period',
  //   Name: "full_name",
  //   "Serial No.":"serial_no",
  //   "Mobile No.": "mobile_no",
  //   "Chasis No.": "chassis_no",
  //   "Vin No.": "vin_no",
  //   "Motor No": "motor_no",
  //   "Battery No": "battery_no",

  //   "Rider Buy Date":"customer_delivery_date",
  //   "Dealer Buy Date": "tradeDate",
  //   "Dealer Selling Date": "customer_delivery_date",
  //   "Vin No.": "vin_no",
  //   "Days": "remaining_days",
  //   "Battery Remaining days (including grace period)": "btybtryremaining_days",
  //   "Controller Remaining days (including grace period)": "cntrlremaining_days",
  //   "Motor Remaining days (including grace period)": "mtrremaining_days",
  //   "Charger Remaining days (including grace period)": "chrgrremaining_days",
  //   "Converter Reamining days (including grace period)": "covrtremaining_days",
  //   // "Warranty From": "warrantyFrom",
  //   // "Warranty To": "warrantyTo",
  //   // "Battery From": "btrywarrantyFrom",
  //   // "Battery To": "btrywarrantyTo",
  //   // "Battery Days": "btybtryremaining_days",

  //   Action: [
  //     { type: "checkclaim", icon: viewIcon, label: "claim" },

  //     { type: "view", icon: eyeIcon, label: "view" },
  //   ],
  // };

  const withOrWithoutGrace = (label) =>
    selectedWarrantyType === "Customer Side"
      ? label.replace(" (including grace period)", "")
      : label;
  
  const BUSINESS_PARTNER_KEY_MAPPING = {
    Name: "full_name",
    "Serial No.": "serial_no",
    "Mobile No.": "mobile_no",
    "Chasis No.": "chassis_no",
    "Vin No.": "vin_no",
    "Motor No": "motor_no",
    "Battery No": "battery_no",
  
    "Customer Buy Date": "customer_delivery_date",
    "Dealer Buy Date": "tradeDate",
    "Dealer Selling Date": "customer_delivery_date",
    "Days": "remaining_days",
  
    [withOrWithoutGrace("Battery Remaining days")]:
      "btybtryremaining_days",
  
    [withOrWithoutGrace("Controller Remaining days")]:
      "cntrlremaining_days",
  
    [withOrWithoutGrace("Motor Remaining days")]:
      "mtrremaining_days",
  
    [withOrWithoutGrace("Charger Remaining days")]:
      "chrgrremaining_days",
  
    [withOrWithoutGrace("Converter Reamining days")]:
      "covrtremaining_days",

      [withOrWithoutGrace("Battery Replacement Remaining days")]:
      "batteryreplacementremaining_day",
      [withOrWithoutGrace("MCB Remaining days")]:
      "mcbremaining_days",
      [withOrWithoutGrace("Throttle Remaining days")]:
      "throtteremaining_days",
      [withOrWithoutGrace("Horn Remaining days")]:
      "hornremaining_days",
      [withOrWithoutGrace("Lights Remaining days")]:
      "lightsremaining_days",
      [withOrWithoutGrace("Ignition Key Remaining days")]:
      "ignKeyremaining_days",
      [withOrWithoutGrace("Shock Absorbers Remaining days")]:
      "shockremaining_days",
      [withOrWithoutGrace("Wiring Remaining days")]:
      "wiringremaining_days",

    // formatHeader("Battery Replacement Remaining days"),
    // formatHeader("MCB Remaining days"),
    // formatHeader("Throttle Remaining days"),
    // formatHeader("Horn Remaining days"),
    // formatHeader("Lights Remaining days"),
    // formatHeader("Ignition Key Remaining days"),
    // formatHeader("Shock Absorbers Remaining days"),
    // formatHeader("Wiring Remaining days"),
    
  
    Action: [
      // { type: "checkclaim", icon: viewIcon, label: "claim" },
      { type: "view", icon: eyeIcon, label: "view" },
    ],
  };

  // hqjdbj3

  const onclickFilter = (row) => {
    setFilterList(row);
  };

  useEffect(() => {
    if (selectedWarrantyType === "Dealer Side") {
      fetchJobCardList();
    }
  }, [filters]);

  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    setSearchTerm("");
    setVinNoData([]); // <-- Clear the table data
    // setIsSearchPerformed(false);
  };

  useEffect(() => {
    if (searchTerm === "") {
      if (selectedWarrantyType === "Dealer Side") {
        fetchJobCardList();
      } else if (selectedWarrantyType === "Customer Side") {
        fetchCustomerWarrantyData();
      }
    }
  }, [searchTerm]);

  const handleSearch = () => {
    // if (!searchTerm || !selectedWarrantyType) {
    //   alert("Please select Admin or Dealer and enter a VIN number.");
    //   return;
    // }
    setFilters({ vinNumber: searchTerm });
    setIsSearchPerformed(true);                                                                                      

    if (selectedWarrantyType === "Dealer Side") {
      fetchJobCardList();
    } else if (selectedWarrantyType === "Customer Side") {
      fetchCustomerWarrantyData();
    }
  };

  const clearSearchAndFetch = () => {
    setSearchTerm("");
  };

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleClear = () => {
    // setSearchTerm("");
    // setSelectedWarrantyType("");
    // setIsSearchPerformed(false);
    setFilterFormData({});
    setFilters({});
  };
  // const handleClaim = () => {

  //   console.log("clicked")

  //   navigate(ROUTES_NAVIGATION.ADDJOBCARD , ROUTES_NAVIGATION.GENERATEORDER)

  // }

  // const handleClaim = (row) => {
  //   console.log("clicked", row.customer_id);

  //   if (remainingDays === 0) {
  //     navigate(ROUTES_NAVIGATION.GENERATEORDER);
  //   } else {
  //     navigate(ROUTES_NAVIGATION.ADDJOBCARD, {
  //       state: { customer_id: row.vin_no },
  //     });
  //   }
  // };

  // const handleClaim = (row) => {
  //   console.log("clicked", row.vin_no);

  //   if (remainingDays === 0) {
  //     navigate(ROUTES_NAVIGATION.GENERATEORDER);
  //   } else {
  //     navigate(ROUTES_NAVIGATION.ADDJOBCARD, {
  //       state: { customer_id: row.vin_no },
  //     });
  //   }
  // };

  const handleClaim = (row) => {
    console.log("clicked", row.vin_no);
    console.log("warrantyType", row.warrantyType)
  
    if (remainingDays === 0) {
      navigate(ROUTES_NAVIGATION.GENERATEORDER);
    } else {
      navigate(ROUTES_NAVIGATION.ADDJOBCARD, {
        state: {
          customer_id: row.vin_no,
          warrantyType: row.warrantyType, // add this line
        },
      });
    }
  };

  // const downloadExcel = () => {
  //   if (!vinNoData || vinNoData.length === 0) {
  //     alert("No data available to export.");
  //     return;
  //   }
  
  //   const worksheet = XLSX.utils.json_to_sheet(vinNoData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "VIN Data");
  
  //   const excelBuffer = XLSX.write(workbook, {
  //     bookType: "xlsx",
  //     type: "array",
  //   });
  
  //   const data = new Blob([excelBuffer], { type: "application/octet-stream" });
  //   saveAs(data, "VinData.xlsx");
  // };

  const downloadExcel = () => {
    const pageSize = 10; // or your actual page size from state/config
    const start = currentPage * pageSize;
    const end = start + pageSize;
    const pageData = vinNoData.slice(start, end);
  
    if (pageData.length === 0) {
      alert("No data available to export.");
      return;
    }
  
    // Automatically includes all keys in the columns
    const worksheet = XLSX.utils.json_to_sheet(pageData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Page Data");
  
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
  
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, `VinData_Page_${currentPage + 1}.xlsx`);
  };
  
  return (
    <div>
      <div className="OnboardManagamentContainer ">
        <div className="OnboardManagamentbuttonContainer sales-warranty-check-heading  col-md-3 mt-2 mb-2">
          <div
            style={{
              lineHeight: "1px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div>
              <p className="ServiceBreadcrumbs">
                Home / Warranty Management / Check Warranty
              </p>
            </div>
            <div>
              <h5
                style={{ fontWeight: "600" }}
                className="checkWarrantyHeading"
              >
                Check Warranty
              </h5>
            </div>
          </div>
        </div>
        <div className=" col-md-8 mt-2 mb-2 gap-2 totalvaluescontainer">
          <div className="listSideBorder" />
        </div>
      </div>
      <div className="check-warranty-box">
        <div className="tableWrapper">
          <div style={{ flexDirection: "column" }} className="filterView">
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              className="filterLeftView col-md-12 pt-4 gap-2"
            >
              {/* Admin / Dealer Buttons */}
              <div className="tab-header" style={{ width: "100%" }}>
                <button
                  className={`tab-button ${
                    selectedWarrantyType === "Dealer Side" ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedWarrantyType("Dealer Side");
                    setSearchTerm("");
                    setIsSearchPerformed(true);
                    fetchJobCardList();
                  }}
                >
                  Dealer
                </button>
                <button
                  className={`tab-button ${
                    selectedWarrantyType === "Customer Side" ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedWarrantyType("Customer Side");
                    setSearchTerm("");
                    setIsSearchPerformed(true);
                    fetchCustomerWarrantyData();
                  }}
                >
                  Customer
                </button>
              </div>
            </div>
          </div>

          <div className="tab-divider"></div>

          {/* Table Section */}
          {(isSearchPerformed || vinNoData?.length > 0) && (
            <div className="tab-content">
              <div className="searchinput-wrapper">
                <input
                  type="text"
                  className="searchinputbyVin"
                  placeholder="Search By Vin No./Serial No./Mobile No."
                  value={searchTerm}
                  onChange={handleSearchInputChange}
                />
                {/* <button className="flte-btn check-warranty-search" onClick={handleSearch}>
                  Search
                </button>
                <button className="clear-btn check-warranty-scan" onClick={handleClear}>
                  Clear
                </button> */}
                <ListLogisticsFilters
                  formConfig={PhysicalStockTakingInputs}
                  formData={filterFormData}
                  setFormData={setFilterFormData}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors}
                  handleSearch={handleSearch}
                  handleClear={clearFilter}
                />
                <div
                  onClick={downloadExcel}
                  className="flte-btnnn"
                  style={{ borderRadius: "38px", cursor: "pointer", marginTop:"2rem" }}
                >
                  Export
                  <span>
                    <FiDownload
                      className="downloadexcel-misreportsales"
                      style={{ cursor: "pointer" }}
                      size={22}
                    />
                  </span>
                </div>
              </div>

              {/* Table */}
              {/* <CustomTable */}
              <CustomHorizontalTable
                data={paginatedData}
                headers={Job_Card_TABLE_HEADERS}
                keyMapping={BUSINESS_PARTNER_KEY_MAPPING}
                onEdit={handleEdit}
                handleViewButton={handleViewButton}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}
                totalPages={Math.ceil(filteredData.length / itemsPerPage)} // Calculated from filteredData
                onPageChange={handlePageChange}
                totalRecords={filteredData.length}
                handleClaim={handleClaim}
                // isADDcomplainTable={true}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminWarrantyCheck;
